/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull instaclause-webapp'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 12
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest)
 *
 * [Full Setup Instructions](https://data.amplitude.com/instaclause-673038/default/implementation/instaclause-webapp)
 */

import * as amplitude from '@amplitude/analytics-browser';

export type Environment = 'default';

export const ApiKey: Record<Environment, string> = {
  default: ''
};

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration: BrowserOptions = {
  plan: {
    version: '12',
    branch: 'main',
    source: 'instaclause-webapp',
    versionId: '2cd599a2-eac8-45a7-8a77-9e98e53df7d2'
  },
  ...{
    ingestionMetadata: {
      sourceName: 'browser-typescript-ampli',
      sourceVersion: '2.0.0'
    }
  }
};

export interface LoadOptionsBase { disabled?: boolean }

export type LoadOptionsWithEnvironment = LoadOptionsBase & { environment: Environment; client?: { configuration?: BrowserOptions; }; };
export type LoadOptionsWithApiKey = LoadOptionsBase & { client: { apiKey: string; configuration?: BrowserOptions; } };
export type LoadOptionsWithClientInstance = LoadOptionsBase & { client: { instance: BrowserClient; } };

export type LoadOptions = LoadOptionsWithEnvironment | LoadOptionsWithApiKey | LoadOptionsWithClientInstance;

export interface IdentifyProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  Customer?: number;
  user_role?: string;
}

export interface AiimportCancelledProperties {
  cancel_step: string;
  source_page: string;
}

export interface AiimportSelectedProperties {
  language: string;
  name: string;
}

export interface AiimporteditorOpenedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  fields_detected: string[];
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  flow_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  roles_detected: string[];
}

export interface AiimportfileUploadedProperties {
  file_size: string;
  file_type: string;
  language: string;
}

export interface AiimportpreviewConfirmedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  fields_detected: string[];
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  preview_duration_ms: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  processing_duration_ms: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  roles_detected: string[];
}

export interface BrandingsettingsOpenedProperties {
  source_page: string;
}

export interface BrandingsettingsSavedProperties {
  field_changed: string;
}

export interface ClauseInsertedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  document_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  flow_id: number;
}

export interface ContractDocumentEditorCancelledProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  contract_document_id: number;
  contract_document_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  contract_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  contract_language_id?: number;
  contract_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  contract_template_model_id: number;
}

export interface ContractDocumentEditorOpenedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  contract_document_id: number;
  contract_document_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  contract_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  contract_language_id?: number;
  contract_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  contract_template_model_id: number;
}

export interface ContractDocumentEditorRestoredProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  contract_document_id: number;
  contract_document_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  contract_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  contract_language_id?: number;
  contract_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  contract_template_model_id: number;
}

export interface ContractDocumentEditorSavedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  contract_document_id: number;
  contract_document_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  contract_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  contract_language_id?: number;
  contract_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  contract_template_model_id: number;
}

export interface DocumentCreatedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  document_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  flow_id: number;
}

export interface DocumentDeletedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  document_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  flow_id: number;
}

export interface DocumentOpenedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  document_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  flow_id: number;
}

export interface DocumentRenamedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  document_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  flow_id: number;
}

export interface FieldCreatedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  field_id: number;
  field_type: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  flow_id: number;
  source: string;
}

export interface FieldDeletedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  field_id: number;
  field_type: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  flow_id: number;
}

export interface FieldOpenedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  field_id: number;
  field_type: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  flow_id: number;
}

export interface FieldTableOpenedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  flow_id: number;
}

export interface FielddisplayToggledProperties {
  display: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  field_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  flow_id: number;
}

export interface FieldoptionAddedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  field_id: number;
  field_type: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  flow_id: number;
}

export interface FieldoptionDuplicatedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  field_id: number;
  field_type: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  flow_id: number;
}

export interface FieldoptionRemovedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  field_id: number;
  field_type: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  flow_id: number;
}

export interface FieldtypeChangedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  field_id: number;
  field_type: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  flow_id: number;
}

export interface FlowCreatedProperties {
  ai_import: boolean;
}

export interface FlowDeletedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  flow_id: number;
}

export interface FlowOpenedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  flow_id: number;
  flow_status: string;
}

export interface FlowPublishLimitBlockedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  flow_limit: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  published_flow_count: number;
  source: string;
  user_role: string;
}

export interface FlowPublishedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  flow_id: number;
  is_first_publish: boolean;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  publish_count: number;
}

export interface FlowSearchedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  query_length: number;
}

export interface FlowlistSortedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | status, last_updated, name |
   */
  sort_by: "status" | "last_updated" | "name";
}

export interface FlowrowmenuOpenedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  flow_id: number;
}

export interface FlowstatusToggledProperties {
  enabled: boolean;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  flow_id: number;
}

export interface FlowtabOpenedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  flow_id: number;
  tab_name: string;
}

export interface HelphubContactSubmittedProperties {
  subject: string;
}

export interface HelphubItemClickedProperties {
  item: string;
  source_page: string;
}

export interface HelphubOpenedProperties {
  source_page: string;
}

export interface ImageInsertedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  document_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  flow_id: number;
}

export interface KvkCompanyImportedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  fields_filled: number;
  persisted: boolean;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | customer_wizard, contract_wizard, integration_tab |
   */
  source: "customer_wizard" | "contract_wizard" | "integration_tab";
}

export interface KvkImportFailedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | not_found, unavailable |
   */
  error_reason: "not_found" | "unavailable";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | customer_wizard, contract_wizard, integration_tab |
   */
  source: "customer_wizard" | "contract_wizard" | "integration_tab";
}

export interface KvkSearchFailedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | not_found, unavailable |
   */
  error_reason: "not_found" | "unavailable";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | customer_wizard, contract_wizard, integration_tab |
   */
  source: "customer_wizard" | "contract_wizard" | "integration_tab";
}

export interface KvkSearchedProperties {
  is_kvk_number: boolean;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  query_length: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  result_count: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | customer_wizard, contract_wizard, integration_tab |
   */
  source: "customer_wizard" | "contract_wizard" | "integration_tab";
}

export interface LanguageSwitchedProperties {
  language: string;
}

export interface LoginProperties {
  /**
   * Which credential the user signed in with.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | password, google, microsoft |
   */
  method: "password" | "google" | "microsoft";
}

export interface NewflowlanguageSelectedProperties {
  language: string;
}

export interface NewflowmanualSelectedProperties {
  language: string;
  name: string;
}

export interface PagebreakInsertedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  document_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  flow_id: number;
}

export interface RoleCreatedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  flow_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  role_id: number;
}

export interface RoleDeletedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  role_id: number;
}

export interface RoleOpenedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  flow_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  role_id: number;
}

export interface RoleSavedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  flow_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  role_id: number;
}

export interface SplitInsertedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  document_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  flow_id: number;
}

export interface TableInsertedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  document_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  flow_id: number;
}

export interface TypographyfontChangedProperties {
  font_family: string;
}

export interface UserAddedProperties {
  user_email: string;
  user_group?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  user_id?: number;
  user_name?: string;
  user_role: string;
}

export interface UserEditedProperties {
  user_email: string;
  user_group?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  user_id?: number;
  user_name?: string;
  user_role: string;
}

export interface UserManagementViewedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  user_count: number;
}

export interface UsergroupCreatedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | number |
   */
  usergroup_contract_models?: number[];
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  usergroup_id: number;
  usergroup_name: string;
}

export interface UsergroupDeletedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | number |
   */
  usergroup_contract_models?: number[];
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  usergroup_id: number;
  usergroup_name: string;
}

export interface UsergroupEditedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | number |
   */
  usergroup_contract_models?: number[];
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  usergroup_id: number;
  usergroup_name: string;
}

export interface UsergroupFilteredProperties {
  filter_type: string;
  filter_value: string;
}

export interface UsergroupSearchedProperties {
  search_term: string;
}

export interface ContractDataProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  contract_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  contract_language_id?: number;
  contract_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  contract_template_model_id: number;
}

export interface ContractDocumentDataProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  contract_document_id: number;
  contract_document_name: string;
}

export interface UserDataProperties {
  user_email: string;
  user_group?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  user_id?: number;
  user_name?: string;
  user_role: string;
}

export interface UsergroupDataProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | number |
   */
  usergroup_contract_models?: number[];
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  usergroup_id: number;
  usergroup_name: string;
}

export class Identify implements BaseEvent {
  event_type = amplitude.Types.SpecialEventType.IDENTIFY;

  constructor(
    public event_properties?: IdentifyProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AiimportCancelled implements BaseEvent {
  event_type = 'aiimport_cancelled';

  constructor(
    public event_properties: AiimportCancelledProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AiimportSelected implements BaseEvent {
  event_type = 'aiimport_selected';

  constructor(
    public event_properties: AiimportSelectedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AiimporteditorOpened implements BaseEvent {
  event_type = 'aiimporteditor_opened';

  constructor(
    public event_properties: AiimporteditorOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AiimportfileUploaded implements BaseEvent {
  event_type = 'aiimportfile_uploaded';

  constructor(
    public event_properties: AiimportfileUploadedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AiimportpreviewConfirmed implements BaseEvent {
  event_type = 'aiimportpreview_confirmed';

  constructor(
    public event_properties: AiimportpreviewConfirmedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class BrandingsettingsOpened implements BaseEvent {
  event_type = 'brandingsettings_opened';

  constructor(
    public event_properties: BrandingsettingsOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class BrandingsettingsSaved implements BaseEvent {
  event_type = 'brandingsettings_saved';

  constructor(
    public event_properties: BrandingsettingsSavedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ClauseInserted implements BaseEvent {
  event_type = 'clause_inserted';

  constructor(
    public event_properties: ClauseInsertedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ContractDocumentEditorCancelled implements BaseEvent {
  event_type = 'contract_document_editor_cancelled';

  constructor(
    public event_properties: ContractDocumentEditorCancelledProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ContractDocumentEditorOpened implements BaseEvent {
  event_type = 'contract_document_editor_opened';

  constructor(
    public event_properties: ContractDocumentEditorOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ContractDocumentEditorRestored implements BaseEvent {
  event_type = 'contract_document_editor_restored';

  constructor(
    public event_properties: ContractDocumentEditorRestoredProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ContractDocumentEditorSaved implements BaseEvent {
  event_type = 'contract_document_editor_saved';

  constructor(
    public event_properties: ContractDocumentEditorSavedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DocumentCreated implements BaseEvent {
  event_type = 'document_created';

  constructor(
    public event_properties: DocumentCreatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DocumentDeleted implements BaseEvent {
  event_type = 'document_deleted';

  constructor(
    public event_properties: DocumentDeletedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DocumentOpened implements BaseEvent {
  event_type = 'document_opened';

  constructor(
    public event_properties: DocumentOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DocumentRenamed implements BaseEvent {
  event_type = 'document_renamed';

  constructor(
    public event_properties: DocumentRenamedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class FieldCreated implements BaseEvent {
  event_type = 'field_created';

  constructor(
    public event_properties: FieldCreatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class FieldDeleted implements BaseEvent {
  event_type = 'field_deleted';

  constructor(
    public event_properties: FieldDeletedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class FieldOpened implements BaseEvent {
  event_type = 'field_opened';

  constructor(
    public event_properties: FieldOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class FieldTableOpened implements BaseEvent {
  event_type = 'field_table_opened';

  constructor(
    public event_properties: FieldTableOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class FielddisplayToggled implements BaseEvent {
  event_type = 'fielddisplay_toggled';

  constructor(
    public event_properties: FielddisplayToggledProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class FieldoptionAdded implements BaseEvent {
  event_type = 'fieldoption_added';

  constructor(
    public event_properties: FieldoptionAddedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class FieldoptionDuplicated implements BaseEvent {
  event_type = 'fieldoption_duplicated';

  constructor(
    public event_properties: FieldoptionDuplicatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class FieldoptionRemoved implements BaseEvent {
  event_type = 'fieldoption_removed';

  constructor(
    public event_properties: FieldoptionRemovedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class FieldtypeChanged implements BaseEvent {
  event_type = 'fieldtype_changed';

  constructor(
    public event_properties: FieldtypeChangedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class FlowCreated implements BaseEvent {
  event_type = 'flow_created';

  constructor(
    public event_properties: FlowCreatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class FlowDeleted implements BaseEvent {
  event_type = 'flow_deleted';

  constructor(
    public event_properties: FlowDeletedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class FlowOpened implements BaseEvent {
  event_type = 'flow_opened';

  constructor(
    public event_properties: FlowOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class FlowPublishLimitBlocked implements BaseEvent {
  event_type = 'flow_publish_limit_blocked';

  constructor(
    public event_properties: FlowPublishLimitBlockedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class FlowPublished implements BaseEvent {
  event_type = 'flow_published';

  constructor(
    public event_properties: FlowPublishedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class FlowSearched implements BaseEvent {
  event_type = 'flow_searched';

  constructor(
    public event_properties: FlowSearchedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class FlowlistSorted implements BaseEvent {
  event_type = 'flowlist_sorted';

  constructor(
    public event_properties: FlowlistSortedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class FlowrowmenuOpened implements BaseEvent {
  event_type = 'flowrowmenu_opened';

  constructor(
    public event_properties: FlowrowmenuOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class FlowstatusToggled implements BaseEvent {
  event_type = 'flowstatus_toggled';

  constructor(
    public event_properties: FlowstatusToggledProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class FlowtabOpened implements BaseEvent {
  event_type = 'flowtab_opened';

  constructor(
    public event_properties: FlowtabOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class FooterbrandingOpened implements BaseEvent {
  event_type = 'footerbranding_opened';
}

export class HeadingstylesOpened implements BaseEvent {
  event_type = 'headingstyles_opened';
}

export class HelphubContactSubmitted implements BaseEvent {
  event_type = 'helphub_contact_submitted';

  constructor(
    public event_properties: HelphubContactSubmittedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class HelphubItemClicked implements BaseEvent {
  event_type = 'helphub_item_clicked';

  constructor(
    public event_properties: HelphubItemClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class HelphubOpened implements BaseEvent {
  event_type = 'helphub_opened';

  constructor(
    public event_properties: HelphubOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ImageInserted implements BaseEvent {
  event_type = 'image_inserted';

  constructor(
    public event_properties: ImageInsertedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class KvkCompanyImported implements BaseEvent {
  event_type = 'kvk_company_imported';

  constructor(
    public event_properties: KvkCompanyImportedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class KvkImportFailed implements BaseEvent {
  event_type = 'kvk_import_failed';

  constructor(
    public event_properties: KvkImportFailedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class KvkSearchFailed implements BaseEvent {
  event_type = 'kvk_search_failed';

  constructor(
    public event_properties: KvkSearchFailedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class KvkSearched implements BaseEvent {
  event_type = 'kvk_searched';

  constructor(
    public event_properties: KvkSearchedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class LanguageSwitched implements BaseEvent {
  event_type = 'language_switched';

  constructor(
    public event_properties: LanguageSwitchedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class Login implements BaseEvent {
  event_type = 'login';

  constructor(
    public event_properties: LoginProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class NewflowlanguageSelected implements BaseEvent {
  event_type = 'newflowlanguage_selected';

  constructor(
    public event_properties: NewflowlanguageSelectedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class NewflowmanualSelected implements BaseEvent {
  event_type = 'newflowmanual_selected';

  constructor(
    public event_properties: NewflowmanualSelectedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PagebreakInserted implements BaseEvent {
  event_type = 'pagebreak_inserted';

  constructor(
    public event_properties: PagebreakInsertedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PasswordResetCompleted implements BaseEvent {
  event_type = 'password_reset_completed';
}

export class PasswordResetRequested implements BaseEvent {
  event_type = 'password_reset_requested';
}

export class RoleCreated implements BaseEvent {
  event_type = 'role_created';

  constructor(
    public event_properties: RoleCreatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class RoleDeleted implements BaseEvent {
  event_type = 'role_deleted';

  constructor(
    public event_properties: RoleDeletedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class RoleListViewed implements BaseEvent {
  event_type = 'role_list_viewed';
}

export class RoleOpened implements BaseEvent {
  event_type = 'role_opened';

  constructor(
    public event_properties: RoleOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class RoleSaved implements BaseEvent {
  event_type = 'role_saved';

  constructor(
    public event_properties: RoleSavedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SplitInserted implements BaseEvent {
  event_type = 'split_inserted';

  constructor(
    public event_properties: SplitInsertedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TableInserted implements BaseEvent {
  event_type = 'table_inserted';

  constructor(
    public event_properties: TableInsertedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TextstylesOpened implements BaseEvent {
  event_type = 'textstyles_opened';
}

export class TrashOpened implements BaseEvent {
  event_type = 'trash_opened';
}

export class TypographyfontChanged implements BaseEvent {
  event_type = 'typographyfont_changed';

  constructor(
    public event_properties: TypographyfontChangedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class UserAdded implements BaseEvent {
  event_type = 'user_added';

  constructor(
    public event_properties: UserAddedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class UserEdited implements BaseEvent {
  event_type = 'user_edited';

  constructor(
    public event_properties: UserEditedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class UserManagementViewed implements BaseEvent {
  event_type = 'user_management_viewed';

  constructor(
    public event_properties: UserManagementViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class UsergroupCreated implements BaseEvent {
  event_type = 'usergroup_created';

  constructor(
    public event_properties: UsergroupCreatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class UsergroupDeleted implements BaseEvent {
  event_type = 'usergroup_deleted';

  constructor(
    public event_properties: UsergroupDeletedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class UsergroupEdited implements BaseEvent {
  event_type = 'usergroup_edited';

  constructor(
    public event_properties: UsergroupEditedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class UsergroupFiltered implements BaseEvent {
  event_type = 'usergroup_filtered';

  constructor(
    public event_properties: UsergroupFilteredProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class UsergroupListViewed implements BaseEvent {
  event_type = 'usergroup_list_viewed';
}

export class UsergroupSearched implements BaseEvent {
  event_type = 'usergroup_searched';

  constructor(
    public event_properties: UsergroupSearchedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export type PromiseResult<T> = { promise: Promise<T | void> };

const getVoidPromiseResult = () => ({ promise: Promise.resolve() });

// prettier-ignore
export class Ampli {
  private disabled: boolean = false;
  private amplitude?: BrowserClient;

  get client(): BrowserClient {
    this.isInitializedAndEnabled();
    return this.amplitude!;
  }

  get isLoaded(): boolean {
    return this.amplitude != null;
  }

  private isInitializedAndEnabled(): boolean {
    if (!this.amplitude) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param options Configuration options to initialize the Ampli SDK with.
   */
  load(options: LoadOptions): PromiseResult<void> {
    this.disabled = options.disabled ?? false;

    if (this.amplitude) {
      console.warn('WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup.');
      return getVoidPromiseResult();
    }

    let apiKey: string | null = null;
    if (options.client && 'apiKey' in options.client) {
      apiKey = options.client.apiKey;
    } else if ('environment' in options) {
      apiKey = ApiKey[options.environment];
    }

    if (options.client && 'instance' in options.client) {
      this.amplitude = options.client.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      const configuration = (options.client && 'configuration' in options.client) ? options.client.configuration : {};
      return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...configuration });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user and set user properties.
   *
   * @param userId The user's id.
   * @param properties The user properties.
   * @param options Optional event options.
   */
  identify(
    userId: string | undefined,
    properties?: IdentifyProperties,
    options?: EventOptions,
  ): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = {...options,  user_id: userId};
    }

    const amplitudeIdentify = new amplitude.Identify();
    const eventProperties = properties;
    if (eventProperties != null) {
      for (const [key, value] of Object.entries(eventProperties)) {
        amplitudeIdentify.set(key, value);
      }
    }
    return this.amplitude!.identify(
      amplitudeIdentify,
      options,
    );
  }

 /**
  * Flush the event.
  */
  flush() : PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.flush();
  }

  /**
   * Track event
   *
   * @param event The event to track.
   * @param options Optional event options.
   */
  track(event: Event, options?: EventOptions): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.track(event, undefined, options);
  }

  /**
   * aiimport_cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/aiimport_cancelled)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. cancel_step)
   * @param options Amplitude event options.
   */
  aiimportCancelled(
    properties: AiimportCancelledProperties,
    options?: EventOptions,
  ) {
    return this.track(new AiimportCancelled(properties), options);
  }

  /**
   * aiimport_selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/aiimport_selected)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. language)
   * @param options Amplitude event options.
   */
  aiimportSelected(
    properties: AiimportSelectedProperties,
    options?: EventOptions,
  ) {
    return this.track(new AiimportSelected(properties), options);
  }

  /**
   * aiimporteditor_opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/aiimporteditor_opened)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. fields_detected)
   * @param options Amplitude event options.
   */
  aiimporteditorOpened(
    properties: AiimporteditorOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new AiimporteditorOpened(properties), options);
  }

  /**
   * aiimportfile_uploaded
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/aiimportfile_uploaded)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. file_size)
   * @param options Amplitude event options.
   */
  aiimportfileUploaded(
    properties: AiimportfileUploadedProperties,
    options?: EventOptions,
  ) {
    return this.track(new AiimportfileUploaded(properties), options);
  }

  /**
   * aiimportpreview_confirmed
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/aiimportpreview_confirmed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. fields_detected)
   * @param options Amplitude event options.
   */
  aiimportpreviewConfirmed(
    properties: AiimportpreviewConfirmedProperties,
    options?: EventOptions,
  ) {
    return this.track(new AiimportpreviewConfirmed(properties), options);
  }

  /**
   * brandingsettings_opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/brandingsettings_opened)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. source_page)
   * @param options Amplitude event options.
   */
  brandingsettingsOpened(
    properties: BrandingsettingsOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new BrandingsettingsOpened(properties), options);
  }

  /**
   * brandingsettings_saved
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/brandingsettings_saved)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. field_changed)
   * @param options Amplitude event options.
   */
  brandingsettingsSaved(
    properties: BrandingsettingsSavedProperties,
    options?: EventOptions,
  ) {
    return this.track(new BrandingsettingsSaved(properties), options);
  }

  /**
   * clause_inserted
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/clause_inserted)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. document_id)
   * @param options Amplitude event options.
   */
  clauseInserted(
    properties: ClauseInsertedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ClauseInserted(properties), options);
  }

  /**
   * contract_document_editor_cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/contract_document_editor_cancelled)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. contract_document_id)
   * @param options Amplitude event options.
   */
  contractDocumentEditorCancelled(
    properties: ContractDocumentEditorCancelledProperties,
    options?: EventOptions,
  ) {
    return this.track(new ContractDocumentEditorCancelled(properties), options);
  }

  /**
   * contract_document_editor_opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/contract_document_editor_opened)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. contract_document_id)
   * @param options Amplitude event options.
   */
  contractDocumentEditorOpened(
    properties: ContractDocumentEditorOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ContractDocumentEditorOpened(properties), options);
  }

  /**
   * contract_document_editor_restored
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/contract_document_editor_restored)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. contract_document_id)
   * @param options Amplitude event options.
   */
  contractDocumentEditorRestored(
    properties: ContractDocumentEditorRestoredProperties,
    options?: EventOptions,
  ) {
    return this.track(new ContractDocumentEditorRestored(properties), options);
  }

  /**
   * contract_document_editor_saved
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/contract_document_editor_saved)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. contract_document_id)
   * @param options Amplitude event options.
   */
  contractDocumentEditorSaved(
    properties: ContractDocumentEditorSavedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ContractDocumentEditorSaved(properties), options);
  }

  /**
   * document_created
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/document_created)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. document_id)
   * @param options Amplitude event options.
   */
  documentCreated(
    properties: DocumentCreatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DocumentCreated(properties), options);
  }

  /**
   * document_deleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/document_deleted)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. document_id)
   * @param options Amplitude event options.
   */
  documentDeleted(
    properties: DocumentDeletedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DocumentDeleted(properties), options);
  }

  /**
   * document_opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/document_opened)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. document_id)
   * @param options Amplitude event options.
   */
  documentOpened(
    properties: DocumentOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DocumentOpened(properties), options);
  }

  /**
   * document_renamed
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/document_renamed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. document_id)
   * @param options Amplitude event options.
   */
  documentRenamed(
    properties: DocumentRenamedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DocumentRenamed(properties), options);
  }

  /**
   * field_created
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/field_created)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. field_id)
   * @param options Amplitude event options.
   */
  fieldCreated(
    properties: FieldCreatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new FieldCreated(properties), options);
  }

  /**
   * field_deleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/field_deleted)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. field_id)
   * @param options Amplitude event options.
   */
  fieldDeleted(
    properties: FieldDeletedProperties,
    options?: EventOptions,
  ) {
    return this.track(new FieldDeleted(properties), options);
  }

  /**
   * field_opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/field_opened)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. field_id)
   * @param options Amplitude event options.
   */
  fieldOpened(
    properties: FieldOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new FieldOpened(properties), options);
  }

  /**
   * field_table_opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/field_table_opened)
   *
   * *Contract Composer Editor opened the fields overview table.*
   *
   * @param properties The event's properties (e.g. flow_id)
   * @param options Amplitude event options.
   */
  fieldTableOpened(
    properties: FieldTableOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new FieldTableOpened(properties), options);
  }

  /**
   * fielddisplay_toggled
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/fielddisplay_toggled)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. display)
   * @param options Amplitude event options.
   */
  fielddisplayToggled(
    properties: FielddisplayToggledProperties,
    options?: EventOptions,
  ) {
    return this.track(new FielddisplayToggled(properties), options);
  }

  /**
   * fieldoption_added
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/fieldoption_added)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. field_id)
   * @param options Amplitude event options.
   */
  fieldoptionAdded(
    properties: FieldoptionAddedProperties,
    options?: EventOptions,
  ) {
    return this.track(new FieldoptionAdded(properties), options);
  }

  /**
   * fieldoption_duplicated
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/fieldoption_duplicated)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. field_id)
   * @param options Amplitude event options.
   */
  fieldoptionDuplicated(
    properties: FieldoptionDuplicatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new FieldoptionDuplicated(properties), options);
  }

  /**
   * fieldoption_removed
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/fieldoption_removed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. field_id)
   * @param options Amplitude event options.
   */
  fieldoptionRemoved(
    properties: FieldoptionRemovedProperties,
    options?: EventOptions,
  ) {
    return this.track(new FieldoptionRemoved(properties), options);
  }

  /**
   * fieldtype_changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/fieldtype_changed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. field_id)
   * @param options Amplitude event options.
   */
  fieldtypeChanged(
    properties: FieldtypeChangedProperties,
    options?: EventOptions,
  ) {
    return this.track(new FieldtypeChanged(properties), options);
  }

  /**
   * flow_created
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/flow_created)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. ai_import)
   * @param options Amplitude event options.
   */
  flowCreated(
    properties: FlowCreatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new FlowCreated(properties), options);
  }

  /**
   * flow_deleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/flow_deleted)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. flow_id)
   * @param options Amplitude event options.
   */
  flowDeleted(
    properties: FlowDeletedProperties,
    options?: EventOptions,
  ) {
    return this.track(new FlowDeleted(properties), options);
  }

  /**
   * flow_opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/flow_opened)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. flow_id)
   * @param options Amplitude event options.
   */
  flowOpened(
    properties: FlowOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new FlowOpened(properties), options);
  }

  /**
   * flow_publish_limit_blocked
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/flow_publish_limit_blocked)
   *
   * User attempts to publish a flow but is blocked by the flow limit.
   *
   * @param properties The event's properties (e.g. flow_limit)
   * @param options Amplitude event options.
   */
  flowPublishLimitBlocked(
    properties: FlowPublishLimitBlockedProperties,
    options?: EventOptions,
  ) {
    return this.track(new FlowPublishLimitBlocked(properties), options);
  }

  /**
   * flow_published
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/flow_published)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. flow_id)
   * @param options Amplitude event options.
   */
  flowPublished(
    properties: FlowPublishedProperties,
    options?: EventOptions,
  ) {
    return this.track(new FlowPublished(properties), options);
  }

  /**
   * flow_searched
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/flow_searched)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. query_length)
   * @param options Amplitude event options.
   */
  flowSearched(
    properties: FlowSearchedProperties,
    options?: EventOptions,
  ) {
    return this.track(new FlowSearched(properties), options);
  }

  /**
   * flowlist_sorted
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/flowlist_sorted)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. sort_by)
   * @param options Amplitude event options.
   */
  flowlistSorted(
    properties: FlowlistSortedProperties,
    options?: EventOptions,
  ) {
    return this.track(new FlowlistSorted(properties), options);
  }

  /**
   * flowrowmenu_opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/flowrowmenu_opened)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. flow_id)
   * @param options Amplitude event options.
   */
  flowrowmenuOpened(
    properties: FlowrowmenuOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new FlowrowmenuOpened(properties), options);
  }

  /**
   * flowstatus_toggled
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/flowstatus_toggled)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. enabled)
   * @param options Amplitude event options.
   */
  flowstatusToggled(
    properties: FlowstatusToggledProperties,
    options?: EventOptions,
  ) {
    return this.track(new FlowstatusToggled(properties), options);
  }

  /**
   * flowtab_opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/flowtab_opened)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. flow_id)
   * @param options Amplitude event options.
   */
  flowtabOpened(
    properties: FlowtabOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new FlowtabOpened(properties), options);
  }

  /**
   * footerbranding_opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/footerbranding_opened)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  footerbrandingOpened(
    options?: EventOptions,
  ) {
    return this.track(new FooterbrandingOpened(), options);
  }

  /**
   * headingstyles_opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/headingstyles_opened)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  headingstylesOpened(
    options?: EventOptions,
  ) {
    return this.track(new HeadingstylesOpened(), options);
  }

  /**
   * helphub_contact_submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/helphub_contact_submitted)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. subject)
   * @param options Amplitude event options.
   */
  helphubContactSubmitted(
    properties: HelphubContactSubmittedProperties,
    options?: EventOptions,
  ) {
    return this.track(new HelphubContactSubmitted(properties), options);
  }

  /**
   * helphub_item_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/helphub_item_clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. item)
   * @param options Amplitude event options.
   */
  helphubItemClicked(
    properties: HelphubItemClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new HelphubItemClicked(properties), options);
  }

  /**
   * helphub_opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/helphub_opened)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. source_page)
   * @param options Amplitude event options.
   */
  helphubOpened(
    properties: HelphubOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new HelphubOpened(properties), options);
  }

  /**
   * image_inserted
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/image_inserted)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. document_id)
   * @param options Amplitude event options.
   */
  imageInserted(
    properties: ImageInsertedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ImageInserted(properties), options);
  }

  /**
   * kvk_company_imported
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/kvk_company_imported)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. fields_filled)
   * @param options Amplitude event options.
   */
  kvkCompanyImported(
    properties: KvkCompanyImportedProperties,
    options?: EventOptions,
  ) {
    return this.track(new KvkCompanyImported(properties), options);
  }

  /**
   * kvk_import_failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/kvk_import_failed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. error_reason)
   * @param options Amplitude event options.
   */
  kvkImportFailed(
    properties: KvkImportFailedProperties,
    options?: EventOptions,
  ) {
    return this.track(new KvkImportFailed(properties), options);
  }

  /**
   * kvk_search_failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/kvk_search_failed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. error_reason)
   * @param options Amplitude event options.
   */
  kvkSearchFailed(
    properties: KvkSearchFailedProperties,
    options?: EventOptions,
  ) {
    return this.track(new KvkSearchFailed(properties), options);
  }

  /**
   * kvk_searched
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/kvk_searched)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. is_kvk_number)
   * @param options Amplitude event options.
   */
  kvkSearched(
    properties: KvkSearchedProperties,
    options?: EventOptions,
  ) {
    return this.track(new KvkSearched(properties), options);
  }

  /**
   * language_switched
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/language_switched)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. language)
   * @param options Amplitude event options.
   */
  languageSwitched(
    properties: LanguageSwitchedProperties,
    options?: EventOptions,
  ) {
    return this.track(new LanguageSwitched(properties), options);
  }

  /**
   * login
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/login)
   *
   * Fired when a user successfully signs in, after the session is created. Sent once per completed sign-in.
   *
   * @param properties The event's properties (e.g. method)
   * @param options Amplitude event options.
   */
  login(
    properties: LoginProperties,
    options?: EventOptions,
  ) {
    return this.track(new Login(properties), options);
  }

  /**
   * newflowlanguage_selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/newflowlanguage_selected)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. language)
   * @param options Amplitude event options.
   */
  newflowlanguageSelected(
    properties: NewflowlanguageSelectedProperties,
    options?: EventOptions,
  ) {
    return this.track(new NewflowlanguageSelected(properties), options);
  }

  /**
   * newflowmanual_selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/newflowmanual_selected)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. language)
   * @param options Amplitude event options.
   */
  newflowmanualSelected(
    properties: NewflowmanualSelectedProperties,
    options?: EventOptions,
  ) {
    return this.track(new NewflowmanualSelected(properties), options);
  }

  /**
   * pagebreak_inserted
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/pagebreak_inserted)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. document_id)
   * @param options Amplitude event options.
   */
  pagebreakInserted(
    properties: PagebreakInsertedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PagebreakInserted(properties), options);
  }

  /**
   * password_reset_completed
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/password_reset_completed)
   *
   * Fired when a user successfully sets a new password from a reset link.
   *
   * @param options Amplitude event options.
   */
  passwordResetCompleted(
    options?: EventOptions,
  ) {
    return this.track(new PasswordResetCompleted(), options);
  }

  /**
   * password_reset_requested
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/password_reset_requested)
   *
   * Fired when a user submits the forgot-password form. Always fired, whether or not the email matches an account, because the backend deliberately does not reveal that.
   *
   * @param options Amplitude event options.
   */
  passwordResetRequested(
    options?: EventOptions,
  ) {
    return this.track(new PasswordResetRequested(), options);
  }

  /**
   * role_created
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/role_created)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. flow_id)
   * @param options Amplitude event options.
   */
  roleCreated(
    properties: RoleCreatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new RoleCreated(properties), options);
  }

  /**
   * role_deleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/role_deleted)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. role_id)
   * @param options Amplitude event options.
   */
  roleDeleted(
    properties: RoleDeletedProperties,
    options?: EventOptions,
  ) {
    return this.track(new RoleDeleted(properties), options);
  }

  /**
   * role_list_viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/role_list_viewed)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  roleListViewed(
    options?: EventOptions,
  ) {
    return this.track(new RoleListViewed(), options);
  }

  /**
   * role_opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/role_opened)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. flow_id)
   * @param options Amplitude event options.
   */
  roleOpened(
    properties: RoleOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new RoleOpened(properties), options);
  }

  /**
   * role_saved
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/role_saved)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. flow_id)
   * @param options Amplitude event options.
   */
  roleSaved(
    properties: RoleSavedProperties,
    options?: EventOptions,
  ) {
    return this.track(new RoleSaved(properties), options);
  }

  /**
   * split_inserted
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/split_inserted)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. document_id)
   * @param options Amplitude event options.
   */
  splitInserted(
    properties: SplitInsertedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SplitInserted(properties), options);
  }

  /**
   * table_inserted
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/table_inserted)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. document_id)
   * @param options Amplitude event options.
   */
  tableInserted(
    properties: TableInsertedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TableInserted(properties), options);
  }

  /**
   * textstyles_opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/textstyles_opened)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  textstylesOpened(
    options?: EventOptions,
  ) {
    return this.track(new TextstylesOpened(), options);
  }

  /**
   * trash_opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/trash_opened)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  trashOpened(
    options?: EventOptions,
  ) {
    return this.track(new TrashOpened(), options);
  }

  /**
   * typographyfont_changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/typographyfont_changed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. font_family)
   * @param options Amplitude event options.
   */
  typographyfontChanged(
    properties: TypographyfontChangedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TypographyfontChanged(properties), options);
  }

  /**
   * user_added
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/user_added)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. user_email)
   * @param options Amplitude event options.
   */
  userAdded(
    properties: UserAddedProperties,
    options?: EventOptions,
  ) {
    return this.track(new UserAdded(properties), options);
  }

  /**
   * user_edited
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/user_edited)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. user_email)
   * @param options Amplitude event options.
   */
  userEdited(
    properties: UserEditedProperties,
    options?: EventOptions,
  ) {
    return this.track(new UserEdited(properties), options);
  }

  /**
   * user_management_viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/user_management_viewed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. user_count)
   * @param options Amplitude event options.
   */
  userManagementViewed(
    properties: UserManagementViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new UserManagementViewed(properties), options);
  }

  /**
   * usergroup_created
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/usergroup_created)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. usergroup_contract_models)
   * @param options Amplitude event options.
   */
  usergroupCreated(
    properties: UsergroupCreatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new UsergroupCreated(properties), options);
  }

  /**
   * usergroup_deleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/usergroup_deleted)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. usergroup_contract_models)
   * @param options Amplitude event options.
   */
  usergroupDeleted(
    properties: UsergroupDeletedProperties,
    options?: EventOptions,
  ) {
    return this.track(new UsergroupDeleted(properties), options);
  }

  /**
   * usergroup_edited
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/usergroup_edited)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. usergroup_contract_models)
   * @param options Amplitude event options.
   */
  usergroupEdited(
    properties: UsergroupEditedProperties,
    options?: EventOptions,
  ) {
    return this.track(new UsergroupEdited(properties), options);
  }

  /**
   * usergroup_filtered
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/usergroup_filtered)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. filter_type)
   * @param options Amplitude event options.
   */
  usergroupFiltered(
    properties: UsergroupFilteredProperties,
    options?: EventOptions,
  ) {
    return this.track(new UsergroupFiltered(properties), options);
  }

  /**
   * usergroup_list_viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/usergroup_list_viewed)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  usergroupListViewed(
    options?: EventOptions,
  ) {
    return this.track(new UsergroupListViewed(), options);
  }

  /**
   * usergroup_searched
   *
   * [View in Tracking Plan](https://data.amplitude.com/instaclause-673038/default/events/main/latest/usergroup_searched)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. search_term)
   * @param options Amplitude event options.
   */
  usergroupSearched(
    properties: UsergroupSearchedProperties,
    options?: EventOptions,
  ) {
    return this.track(new UsergroupSearched(properties), options);
  }
}

export const ampli = new Ampli();

// BASE TYPES
type BrowserOptions = amplitude.Types.BrowserOptions;

export type BrowserClient = amplitude.Types.BrowserClient;
export type BaseEvent = amplitude.Types.BaseEvent;
export type IdentifyEvent = amplitude.Types.IdentifyEvent;
export type GroupEvent = amplitude.Types.GroupIdentifyEvent;
export type Event = amplitude.Types.Event;
export type EventOptions = amplitude.Types.EventOptions;
export type Result = amplitude.Types.Result;
